import AudioUnit from "./AudioUnit";

class Effect extends AudioUnit {

	constructor(type, name, path, number) {
		super(type, name, path);
		this.number = number;
	}

	getNumber() {
		return this.number;
	}
	rehydrate(state) {
		super.rehydrate(state);
		this.number = state.number;
	}

	dehydrate() {
		var state = super.dehydrate();
		state.number = this.number;
		return state;
	}
}

export default Effect;
